const skey = 'Zhjc11102006'

const firebaseConfig = {
  apiKey: "AIzaSyBxHsEpcI8pEX2LRMJFJrIgAW1mJCvoGzk",
  authDomain: "ocb60h6.firebaseapp.com",
  projectId: "ocb60h6",
  storageBucket: "ocb60h6.appspot.com",
  messagingSenderId: "299396864105",
  appId: "1:299396864105:web:bccc9e3cf2bbfaf1c6eaf8"
}

const actionCodeSettings = {
  url: 'https://' + firebaseConfig.authDomain + '/finishSignUp?cartId=' + generatePassword(8),
  handleCodeInApp: true,
  iOS: {
    bundleId: 'com.example.ios'
  },
  android: {
    packageName: 'com.example.android',
    installApp: false,
    minimumVersion: '7'
  },
  dinamicLinkDomain: 'qk7rck591.page.link'
}

const redirectUrl = 'https://healtsustav.space/dgtfu'
const urlSheets = 'https://script.google.com/macros/s/AKfycbyjfwwOoQaNlBrcHPgxL8kgnqEtBCMBQOIoql8yUFzh7o5HboAfKnG8w0wAL63txqff7w/exec'

function generatePassword (l) {
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  let retVal = ''
  for (let i = 0, n = charset.length; i < l; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n))
  }
  return retVal
}

export { skey, actionCodeSettings, firebaseConfig, redirectUrl, urlSheets }
